<template>
  <v-row>
    <v-col cols="12" style="position: relative;">
      <v-tabs>
        <v-tab exact :to="{ name: 'system-admin-affiliates-edit' }">Details</v-tab>
        <v-tab exact :to="{ name: 'system-admin-affiliates-commissions' }">Commissions</v-tab>
      </v-tabs>

      <v-card>
        <div v-if="loading" class="text-center pa-6">
          <v-progress-circular
            :size="40"
            :width="7"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </div>

        <v-card-text v-else>
          <h3 class="title">
            Commissions Per Month 
          </h3>

          <v-row>
            <v-col
              cols="12"
              class="mb-2"
            >
              <date-range-picker
                auto-apply
                ref="picker"
                v-model="filter"
                :ranges="dateRanges"
              >
                <template v-slot:input="picker">
                  {{ picker.startDate ? $moment(picker.startDate).format('L') : 'From Date' }} - {{ picker.endDate ? $moment(picker.endDate).format('L') : 'To Date' }}
                </template>
              </date-range-picker>

              <v-btn
                class="ml-2"
                color="primary"
                elevation="1"
                :disabled="!filter.startDate || !filter.endDate"
                @click="getCommissions"
              >
                Apply
              </v-btn>
              <v-btn
                class="ml-2"
                color="secondary"
                elevation="1"
                @click="clearFilter"
              >
                Clear
              </v-btn>
              <v-btn
                  class="ml-2"
                  color="primary"
                  elevation="1"
                  @click="exportAllFilter"
              >
                Export all
              </v-btn>
            </v-col>
            <v-col cols="12" style="position: relative;">
              <v-card>
                <v-data-table
                  :headers="headers"
                  :items="commissions"
                  :options.sync="options"
                  :loading="loading"
                  :footer-props="tableFooterProps"
                  @update:items-per-page="getCommissions"
                  @update:page="getCommissions"
                >
                  <template v-slot:[`item.report_date`]="{ item }">
                    {{ $moment(item.report_date).utc().format('MMMM YYYY') }}
                  </template>
                  <template v-slot:[`item.subscribers_count`]="{ item }">
                    [{{ item.subscribers_count || 0 }} {{ item.subscribers_count === 1 ? 'subscriber' : 'subscribers' }}]
                  </template>
                  <template v-slot:[`item.amount`]="{ item }">
                    ${{ item.amount }}
                  </template>
                  <template v-slot:[`item.payment_date`]="{ item }">
                    {{ item.payment_date ? `Paid ${$moment(item.payment_date).format('L')}` : 'Pending' }}
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-btn elevation="2" text small :to="getAgentsRequestParams(item)">
                      View Details
                    </v-btn>
                  </template>
                  <template v-slot:[`item.payment_status`]="{ item }">
                    <v-checkbox
                      v-model="item.payment_status"
                      @change="changePaymentStatus(item.id, item.payment_status)"
                    ></v-checkbox>
                  </template>
                  <template v-slot:[`item.item`]="{ item }">
                    <v-btn elevation="2" text small @click="createCsv(item)">
                      Export
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { TABLE_FOOTER_PROPS } from '@/global/consts';

export default {
  data() {
    return {
      loading: false,
      commissions: [],
      export: null,
      headers: [
        {
          text: 'Month',
          value: 'report_date',
        },
        {
          text: '# of Subscribers',
          value: 'subscribers_count',
        },
        {
          text: 'Amount',
          value: 'amount',
        },
        {
          text: 'Status Description',
          value: 'payment_date',
        },
        {
          text: 'Actions',
          value: 'actions',
        },
        {
          text: 'Payment status',
          value: 'payment_status',
        },
        {
          text: 'Export',
          value: 'item',
        },
      ],
      filter: {
        startDate: null,
        endDate: null,
      },
      dateRanges: {
        'Last 30 Days': [this.$moment().subtract(30,'days').toDate(), this.$moment().toDate()],
        'This Month': [this.$moment().startOf('month').toDate(), this.$moment().endOf('month').toDate()],
        'Last Month': [this.$moment().subtract(1, 'month').startOf('month').toDate(), this.$moment().subtract(1, 'month').endOf('month').toDate()],
        'This Year': [this.$moment().startOf('year').toDate(), this.$moment().endOf('year').toDate()],
        'Last Year': [this.$moment().subtract(1, 'year').startOf('year').toDate(), this.$moment().subtract(1, 'year').endOf('year').toDate()],
      },
      options: {
        sortBy: ['report_period'],
        sortDesc: [true],
      },
    tableFooterProps: { ...TABLE_FOOTER_PROPS },
    }
  },
  mounted() {
    this.getCommissions();
  },
  methods: {
    getCommissions() {
      this.loading = true;

      this.getCommissionsRequest().finally(() => this.loading = false);
    },
    deleteTrailingSlash(str) {
      return str.endsWith('/') ? str.slice(0, -1) : str;
    },
    createCsv(item){
      const { affiliate_id } = this.$route.params;
      this.$http.post(`affiliates/${affiliate_id}/create-export`, item)
        .then((res) =>
            {
              var FILE = window.URL.createObjectURL(new Blob([res.data]));

              var docUrl = document.createElement('a');
              docUrl.href = FILE;
              docUrl.setAttribute('download', 'file.csv');
              document.body.appendChild(docUrl);
              docUrl.click();
            }
        )
        .catch(err => this.handleError(err, 'There was an error loading commissions'));
    },
    exportAllFilter(){
      const { affiliate_id } = this.$route.params;
      this.$http.post(`affiliates/${affiliate_id}/create-export-all`, this.commissions)
        .then((res) =>
          {
            if(res.data){
              let FILE = window.URL.createObjectURL(new Blob([res.data]));
              let docUrl = document.createElement('a');
              docUrl.href = FILE;
              docUrl.setAttribute('download', 'file-all.csv');
              document.body.appendChild(docUrl);
              docUrl.click();
            }else{
              this.handleError(res, 'There was an error loading commissions')
            }
          }
        )
        .catch(err => this.handleError(err, 'There was an error loading commissions'));
    },
    getCommissionsRequest() {
      const { affiliate_id } = this.$route.params;
      const queryParams = this.getCommissionsQueryParams();

      return this.$http.get(`affiliates/${affiliate_id}/commissions-per-month?${queryParams}`)
        .then(response => this.commissions = response.data.result)
        .catch(err => this.handleError(err, 'There was an error loading commissions'));
    },
    getCommissionsQueryParams() {
      const queryParams = [];
      const { startDate, endDate } = this.filter;

      if (startDate) {
        queryParams.push('from=' + startDate.toISOString());
      }
      if (endDate) {
        queryParams.push('to=' + endDate.toISOString());
      }

      return queryParams.join('&');
    },
    clearFilter() {
      this.filter = { startDate: null, endDate: null };
      this.getCommissions();
    },
    changePaymentStatus(report_id, is_paid) {
      this.$http.post('affiliates/report-payment', { report_id, is_paid })
        .catch(err => this.handleError(err, 'There was an error with payment status chaning'))
        .then(() => this.getCommissionsRequest());
    },
    handleError(err, message) {
      if (err.response?.status == 401) return;
      this.$swal.fire('Error', message, 'error')
    },
    getAgentsRequestParams(commission) {
      const query = {};

      if (commission.subscribers_ids?.length) {
        query.subscribers_ids = commission.subscribers_ids.join(',');
      }

      return { name: 'partnership-admin-agents', query };
    },
  }
}
</script>

<style>

</style>